import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { ProgressStepsModule } from '@libs/src/progress-steps/progress-steps.module';
import { GroupAccountGoalsModule } from '@main-client/src/app/group-account-goals/group-account-goals.module';
import { FindPipeModule } from '@main-client/src/app/pipes/find-pipe/find-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { UserOnboardingViewGoalSettingComponent } from './user-onboarding-view-goal-setting.component';

@NgModule({
  declarations: [UserOnboardingViewGoalSettingComponent],
  exports: [UserOnboardingViewGoalSettingComponent],
  imports: [
    AvatarModule,
    CommonModule,
    GroupAccountGoalsModule,
    FindPipeModule,
    FlexLayoutModule,
    MatButtonModule,
    MatProgressBarModule,
    NzIconModule,
    ProgressStepsModule,
    TranslationLookupModule,
  ],
})
export class UserOnboardingViewGoalSettingModule {}
